<script setup lang="ts">import { computed as _computed } from 'vue';

import SEllipsisTooltip from '@/components/SEllipsisTooltip/SEllipsisTooltip.vue';
import i18n from '@/i18n';

interface MonitorMutingStatusProps {
  status: 'MUTED' | 'NOT_MUTED';
}

const props = defineProps({
  status: null
});

const text = _computed(() => i18n.t(`tree_selector.${props.status}`));
const icon = _computed(() => (props.status === 'MUTED' ? 'icon-alert-off' : 'icon-alert'));
</script>

<template lang="pug">
.d-flex.align-center
  SIcon.mr-1( size="default" color="iconNeutral" :icon="icon" )
  SEllipsisTooltip.textPrimary--text( :content="text" )
</template>
